module.exports = __webpack_public_path__ + "img/ticket.11757696.svg";